import React from 'react';
const points = [{
  emoji: '😰',
  text: "L'anxiété d'arriver au gymnase sans savoir exactement quelle activité proposer aujourd'hui"
}, {
  emoji: '⏱️',
  text: 'Perdre des heures à écrire des programmations annuelles que vous pourriez résoudre en quelques clics'
}, {
  emoji: '🤷',
  text: 'Urgence pluie ou gymnase occupé : vous bloquez quand vous devez rester en classe'
}, {
  emoji: '📊',
  text: 'Aucun critère clair : vous ne savez pas comment évaluer objectivement votre classe'
}, {
  emoji: '😓',
  text: 'Élèves démotivés qui finissent toujours par faire un "match libre" sans but pédagogique'
}, {
  emoji: '😩',
  text: 'Dimanches soir gâchés pour préparer les cours du lundi matin'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-102">
            👉 Vous reconnaissez-vous dans ces situations ?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-103">
            Si vous répondez "OUI" à l'une de ces questions, ce pack est pour
            vous
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-104">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-105">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-106">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-107">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-108">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-109">
            Vous méritez mieux… et c'est ici qu'intervient Edulabs France →
          </p>
        </div>
      </div>
    </section>;
}